// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let Stdlib = require("@rescript/runtime/lib/js/Stdlib.js");
let Numeral = require("../../utils/Numeral.bs.js");
let V4 = require("uuid/v4");
let DialogV5 = require("../common/Components/DialogV5.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Formality = require("@tan/formality/src/Formality.bs.js");
let Belt_Array = require("@rescript/runtime/lib/js/Belt_Array.js");
let MediaQuery = require("../../reason/common/Media/MediaQuery.bs.js");
let Stdlib_Int = require("@rescript/runtime/lib/js/Stdlib_Int.js");
let Form__Switch = require("../common/Components/Form__Switch.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let TogglesGroup = require("../../uikit/reason/molecules/TogglesGroup/TogglesGroup.bs.js");
let ConfirmDialog = require("../common/Components/ConfirmDialog.bs.js");
let Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Form__Checkbox = require("../common/Components/Form__Checkbox.bs.js");
let SystemMessages = require("../../reason/systemMessages/SystemMessages.bs.js");
let Form__Components = require("../../reason/common/Form/Form__Components.bs.js");
let Primitive_object = require("@rescript/runtime/lib/js/Primitive_object.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let Form__Validators2 = require("../../reason/common/Form/Form__Validators2.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let Formality__ReactUpdate = require("@tan/formality/src/Formality__ReactUpdate.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let NotificationSettingsUtils = require("./NotificationSettingsUtils.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let NotificationSettingsPreferenceEditDialogAreaGroups = require("./NotificationSettingsPreferenceEditDialogAreaGroups.bs.js");
let NotificationSettingsPreferenceEditDialog_chapter_graphql = require("../../__generated__/NotificationSettingsPreferenceEditDialog_chapter_graphql.bs.js");
let NotificationSettingsPreferenceEditDialog_settings_graphql = require("../../__generated__/NotificationSettingsPreferenceEditDialog_settings_graphql.bs.js");
let NotificationSettingsPreferenceEditDialog_areaGroup_graphql = require("../../__generated__/NotificationSettingsPreferenceEditDialog_areaGroup_graphql.bs.js");
let NotificationSettingsPreferenceEditDialog_clientNeed_graphql = require("../../__generated__/NotificationSettingsPreferenceEditDialog_clientNeed_graphql.bs.js");
let NotificationSettingsPreferenceEditDialog_preference_graphql = require("../../__generated__/NotificationSettingsPreferenceEditDialog_preference_graphql.bs.js");
let NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql = require("../../__generated__/NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql.bs.js");

function NotificationSettingsPreferenceEditDialog$CheckSection(props) {
  let helpText = props.helpText;
  let renderWhenClosed = props.renderWhenClosed;
  let isOpen = props.isOpen;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("label", {
          children: [
            JsxRuntime.jsx(Form__Switch.make, {
              on: isOpen,
              onToggle: props.onUpdate
            }),
            JsxRuntime.jsx("div", {
              children: props.title,
              className: "ml-2 font-semibold text-lg"
            })
          ],
          className: "flex flex-row items-center text-gray-800"
        })
      }),
      isOpen ? JsxRuntime.jsxs("div", {
          children: [
            helpText !== undefined ? JsxRuntime.jsx("div", {
                children: helpText,
                className: "text-gray-500 italic leading-6"
              }) : null,
            props.children
          ],
          className: "mt-2 px-2"
        }) : (
          renderWhenClosed !== undefined ? JsxRuntime.jsx("div", {
              children: renderWhenClosed,
              className: "mt-2 px-2"
            }) : null
        )
    ],
    className: "p-4"
  });
}

let CheckSection = {
  make: NotificationSettingsPreferenceEditDialog$CheckSection
};

function NotificationSettingsPreferenceEditDialog$ConfirmDiscardChangesDialog(props) {
  let onDiscardChanges = props.onDiscardChanges;
  let onKeepChanges = props.onKeepChanges;
  return JsxRuntime.jsx(ConfirmDialog.make, {
    title: "Discard Your Changes?",
    ariaLabel: "Discard Your Changes?",
    body: JsxRuntime.jsx("div", {
      children: "Do you wish to discard the changes you've made?"
    }),
    isOpen: props.isOpen,
    onCancel: onKeepChanges,
    cancelButton: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
      onClick: param => onKeepChanges(),
      children: `Keep Editing`
    }),
    confirmButton: JsxRuntime.jsx(ButtonsV5.DangerButton.make, {
      onClick: param => onDiscardChanges(),
      children: `Discard Changes`
    })
  });
}

let ConfirmDiscardChangesDialog = {
  make: NotificationSettingsPreferenceEditDialog$ConfirmDiscardChangesDialog
};

let validators_minPriceToggle = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => ({
    TAG: "Ok",
    _0: param.minPriceToggle
  })
};

let validators_minPrice = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (state, param) => {
    if (!state.minPriceToggle) {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
    let tanType = param.tanType;
    let validated = Form__Validators2.chain(state, [
      param => Form__Validators2.isNotNone(param.minPrice),
      param => Form__Validators2.validateIfNotNone(param.minPrice, extra => Form__Validators2.isMoreThan(true, tanType === "RENTAL" ? 750 : 50000, extra)),
      param => Form__Validators2.validateIfNotNone(param.minPrice, extra => Form__Validators2.isLessThan(true, 1000000000, extra)),
      param => {
        let maxPrice = param.maxPrice;
        let minPrice = param.minPrice;
        if (minPrice !== undefined && maxPrice !== undefined) {
          if (maxPrice > minPrice) {
            return {
              TAG: "Ok",
              _0: minPrice
            };
          } else {
            return {
              TAG: "Error",
              _0: "must be less than the maximum price"
            };
          }
        } else {
          return {
            TAG: "Ok",
            _0: minPrice
          };
        }
      }
    ]);
    if (validated.TAG === "Ok") {
      return {
        TAG: "Ok",
        _0: validated._0.minPrice
      };
    } else {
      return {
        TAG: "Error",
        _0: validated._0
      };
    }
  }
};

let validators_maxPriceToggle = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => ({
    TAG: "Ok",
    _0: param.maxPriceToggle
  })
};

let validators_maxPrice = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (state, param) => {
    if (!state.maxPriceToggle) {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
    let tanType = param.tanType;
    let validated = Form__Validators2.chain(state, [
      param => Form__Validators2.isNotNone(param.maxPrice),
      param => Form__Validators2.validateIfNotNone(param.maxPrice, extra => Form__Validators2.isMoreThan(true, tanType === "RENTAL" ? 1000 : 100000, extra)),
      param => Form__Validators2.validateIfNotNone(param.maxPrice, extra => Form__Validators2.isLessThan(true, 1000000000, extra)),
      param => {
        let maxPrice = param.maxPrice;
        let minPrice = param.minPrice;
        if (minPrice !== undefined && maxPrice !== undefined) {
          if (maxPrice > minPrice) {
            return {
              TAG: "Ok",
              _0: maxPrice
            };
          } else {
            return {
              TAG: "Error",
              _0: "must be more than the minimum price"
            };
          }
        } else {
          return {
            TAG: "Ok",
            _0: maxPrice
          };
        }
      }
    ]);
    if (validated.TAG === "Ok") {
      return {
        TAG: "Ok",
        _0: validated._0.maxPrice
      };
    } else {
      return {
        TAG: "Error",
        _0: validated._0
      };
    }
  }
};

let validators_propertyTypesToggle = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => ({
    TAG: "Ok",
    _0: param.propertyTypesToggle
  })
};

let validators_propertyTypes = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let propertyTypes = param.propertyTypes;
    if (param.propertyTypesToggle) {
      if (propertyTypes.length !== 0) {
        return {
          TAG: "Ok",
          _0: propertyTypes
        };
      } else {
        return {
          TAG: "Error",
          _0: "You must select at least one property type"
        };
      }
    } else {
      return {
        TAG: "Ok",
        _0: []
      };
    }
  }
};

let validators_mlsStatus = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => ({
    TAG: "Ok",
    _0: param.mlsStatus
  })
};

let validators_areaGroup = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let areaGroup = param.areaGroup;
    let areas;
    switch (areaGroup.TAG) {
      case "UserAreaGroup" :
        areas = areaGroup.areas;
        break;
      case "ChapterAreaGroup" :
        return {
          TAG: "Ok",
          _0: areaGroup
        };
      case "NewAreaGroup" :
        areas = areaGroup.areas;
        break;
    }
    if (areas.length !== 0) {
      return {
        TAG: "Ok",
        _0: areaGroup
      };
    } else {
      return {
        TAG: "Error",
        _0: "You must select at least one area"
      };
    }
  }
};

let validators = {
  minPriceToggle: validators_minPriceToggle,
  minPrice: validators_minPrice,
  maxPriceToggle: validators_maxPriceToggle,
  maxPrice: validators_maxPrice,
  propertyTypesToggle: validators_propertyTypesToggle,
  propertyTypes: validators_propertyTypes,
  mlsStatus: validators_mlsStatus,
  areaGroup: validators_areaGroup
};

function initialFieldsStatuses(input) {
  return {
    minPriceToggle: "Pristine",
    minPrice: "Pristine",
    maxPriceToggle: "Pristine",
    maxPrice: "Pristine",
    propertyTypesToggle: "Pristine",
    propertyTypes: "Pristine",
    mlsStatus: "Pristine",
    areaGroup: "Pristine"
  };
}

let initialFieldStatuses_xxx = initialFieldsStatuses;

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: initialFieldsStatuses(input),
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  let match = fieldsStatuses.minPriceToggle;
  let tmp;
  tmp = typeof match !== "object" ? validators.minPriceToggle.validate(input, metadata) : match._0;
  let match$1 = fieldsStatuses.minPrice;
  let tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.minPrice.validate(input, metadata) : match$1._0;
  let match$2 = fieldsStatuses.maxPriceToggle;
  let tmp$2;
  tmp$2 = typeof match$2 !== "object" ? validators.maxPriceToggle.validate(input, metadata) : match$2._0;
  let match$3 = fieldsStatuses.maxPrice;
  let tmp$3;
  tmp$3 = typeof match$3 !== "object" ? validators.maxPrice.validate(input, metadata) : match$3._0;
  let match$4 = fieldsStatuses.propertyTypesToggle;
  let tmp$4;
  tmp$4 = typeof match$4 !== "object" ? validators.propertyTypesToggle.validate(input, metadata) : match$4._0;
  let match$5 = fieldsStatuses.propertyTypes;
  let tmp$5;
  tmp$5 = typeof match$5 !== "object" ? validators.propertyTypes.validate(input, metadata) : match$5._0;
  let match$6 = fieldsStatuses.mlsStatus;
  let tmp$6;
  tmp$6 = typeof match$6 !== "object" ? validators.mlsStatus.validate(input, metadata) : match$6._0;
  let match$7 = fieldsStatuses.areaGroup;
  let tmp$7;
  tmp$7 = typeof match$7 !== "object" ? validators.areaGroup.validate(input, metadata) : match$7._0;
  let minPriceToggleResult = tmp;
  let minPriceToggleResult$1;
  if (minPriceToggleResult.TAG === "Ok") {
    let minPriceResult = tmp$1;
    if (minPriceResult.TAG === "Ok") {
      let maxPriceToggleResult = tmp$2;
      if (maxPriceToggleResult.TAG === "Ok") {
        let maxPriceResult = tmp$3;
        if (maxPriceResult.TAG === "Ok") {
          let propertyTypesToggleResult = tmp$4;
          if (propertyTypesToggleResult.TAG === "Ok") {
            let propertyTypesResult = tmp$5;
            if (propertyTypesResult.TAG === "Ok") {
              let mlsStatusResult = tmp$6;
              if (mlsStatusResult.TAG === "Ok") {
                let areaGroupResult = tmp$7;
                if (areaGroupResult.TAG === "Ok") {
                  return {
                    TAG: "Valid",
                    output: {
                      minPriceToggle: minPriceToggleResult._0,
                      minPrice: minPriceResult._0,
                      maxPriceToggle: maxPriceToggleResult._0,
                      maxPrice: maxPriceResult._0,
                      propertyTypesToggle: propertyTypesToggleResult._0,
                      propertyTypes: propertyTypesResult._0,
                      mlsStatus: mlsStatusResult._0,
                      areaGroup: areaGroupResult._0
                    },
                    fieldsStatuses: {
                      minPriceToggle: {
                        TAG: "Dirty",
                        _0: minPriceToggleResult,
                        _1: "Shown"
                      },
                      minPrice: {
                        TAG: "Dirty",
                        _0: minPriceResult,
                        _1: "Shown"
                      },
                      maxPriceToggle: {
                        TAG: "Dirty",
                        _0: maxPriceToggleResult,
                        _1: "Shown"
                      },
                      maxPrice: {
                        TAG: "Dirty",
                        _0: maxPriceResult,
                        _1: "Shown"
                      },
                      propertyTypesToggle: {
                        TAG: "Dirty",
                        _0: propertyTypesToggleResult,
                        _1: "Shown"
                      },
                      propertyTypes: {
                        TAG: "Dirty",
                        _0: propertyTypesResult,
                        _1: "Shown"
                      },
                      mlsStatus: {
                        TAG: "Dirty",
                        _0: mlsStatusResult,
                        _1: "Shown"
                      },
                      areaGroup: {
                        TAG: "Dirty",
                        _0: areaGroupResult,
                        _1: "Shown"
                      }
                    },
                    collectionsStatuses: undefined
                  };
                }
                minPriceToggleResult$1 = minPriceToggleResult;
              } else {
                minPriceToggleResult$1 = minPriceToggleResult;
              }
            } else {
              minPriceToggleResult$1 = minPriceToggleResult;
            }
          } else {
            minPriceToggleResult$1 = minPriceToggleResult;
          }
        } else {
          minPriceToggleResult$1 = minPriceToggleResult;
        }
      } else {
        minPriceToggleResult$1 = minPriceToggleResult;
      }
    } else {
      minPriceToggleResult$1 = minPriceToggleResult;
    }
  } else {
    minPriceToggleResult$1 = minPriceToggleResult;
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      minPriceToggle: {
        TAG: "Dirty",
        _0: minPriceToggleResult$1,
        _1: "Shown"
      },
      minPrice: {
        TAG: "Dirty",
        _0: tmp$1,
        _1: "Shown"
      },
      maxPriceToggle: {
        TAG: "Dirty",
        _0: tmp$2,
        _1: "Shown"
      },
      maxPrice: {
        TAG: "Dirty",
        _0: tmp$3,
        _1: "Shown"
      },
      propertyTypesToggle: {
        TAG: "Dirty",
        _0: tmp$4,
        _1: "Shown"
      },
      propertyTypes: {
        TAG: "Dirty",
        _0: tmp$5,
        _1: "Shown"
      },
      mlsStatus: {
        TAG: "Dirty",
        _0: tmp$6,
        _1: "Shown"
      },
      areaGroup: {
        TAG: "Dirty",
        _0: tmp$7,
        _1: "Shown"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, metadata, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurMinPriceToggleField" :
          let result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.minPriceToggle, validators_minPriceToggle, status => {
            let init = state.fieldsStatuses;
            return {
              minPriceToggle: status,
              minPrice: init.minPrice,
              maxPriceToggle: init.maxPriceToggle,
              maxPrice: init.maxPrice,
              propertyTypesToggle: init.propertyTypesToggle,
              propertyTypes: init.propertyTypes,
              mlsStatus: init.mlsStatus,
              areaGroup: init.areaGroup
            };
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurMinPriceField" :
          let result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.minPrice, validators_minPrice, status => {
            let init = state.fieldsStatuses;
            return {
              minPriceToggle: init.minPriceToggle,
              minPrice: status,
              maxPriceToggle: init.maxPriceToggle,
              maxPrice: init.maxPrice,
              propertyTypesToggle: init.propertyTypesToggle,
              propertyTypes: init.propertyTypes,
              mlsStatus: init.mlsStatus,
              areaGroup: init.areaGroup
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurMaxPriceToggleField" :
          let result$2 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.maxPriceToggle, validators_maxPriceToggle, status => {
            let init = state.fieldsStatuses;
            return {
              minPriceToggle: init.minPriceToggle,
              minPrice: init.minPrice,
              maxPriceToggle: status,
              maxPrice: init.maxPrice,
              propertyTypesToggle: init.propertyTypesToggle,
              propertyTypes: init.propertyTypes,
              mlsStatus: init.mlsStatus,
              areaGroup: init.areaGroup
            };
          });
          if (result$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$2,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurMaxPriceField" :
          let result$3 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.maxPrice, validators_maxPrice, status => {
            let init = state.fieldsStatuses;
            return {
              minPriceToggle: init.minPriceToggle,
              minPrice: init.minPrice,
              maxPriceToggle: init.maxPriceToggle,
              maxPrice: status,
              propertyTypesToggle: init.propertyTypesToggle,
              propertyTypes: init.propertyTypes,
              mlsStatus: init.mlsStatus,
              areaGroup: init.areaGroup
            };
          });
          if (result$3 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$3,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurPropertyTypesToggleField" :
          let result$4 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.propertyTypesToggle, validators_propertyTypesToggle, status => {
            let init = state.fieldsStatuses;
            return {
              minPriceToggle: init.minPriceToggle,
              minPrice: init.minPrice,
              maxPriceToggle: init.maxPriceToggle,
              maxPrice: init.maxPrice,
              propertyTypesToggle: status,
              propertyTypes: init.propertyTypes,
              mlsStatus: init.mlsStatus,
              areaGroup: init.areaGroup
            };
          });
          if (result$4 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$4,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurPropertyTypesField" :
          let result$5 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.propertyTypes, validators_propertyTypes, status => {
            let init = state.fieldsStatuses;
            return {
              minPriceToggle: init.minPriceToggle,
              minPrice: init.minPrice,
              maxPriceToggle: init.maxPriceToggle,
              maxPrice: init.maxPrice,
              propertyTypesToggle: init.propertyTypesToggle,
              propertyTypes: status,
              mlsStatus: init.mlsStatus,
              areaGroup: init.areaGroup
            };
          });
          if (result$5 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$5,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurMlsStatusField" :
          let result$6 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.mlsStatus, validators_mlsStatus, status => {
            let init = state.fieldsStatuses;
            return {
              minPriceToggle: init.minPriceToggle,
              minPrice: init.minPrice,
              maxPriceToggle: init.maxPriceToggle,
              maxPrice: init.maxPrice,
              propertyTypesToggle: init.propertyTypesToggle,
              propertyTypes: init.propertyTypes,
              mlsStatus: status,
              areaGroup: init.areaGroup
            };
          });
          if (result$6 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$6,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurAreaGroupField" :
          let result$7 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.areaGroup, validators_areaGroup, status => {
            let init = state.fieldsStatuses;
            return {
              minPriceToggle: init.minPriceToggle,
              minPrice: init.minPrice,
              maxPriceToggle: init.maxPriceToggle,
              maxPrice: init.maxPrice,
              propertyTypesToggle: init.propertyTypesToggle,
              propertyTypes: init.propertyTypes,
              mlsStatus: init.mlsStatus,
              areaGroup: status
            };
          });
          if (result$7 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$7,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let apply_validate = validateForm;
          let match$1 = apply_validate(state.input, validators, state.fieldsStatuses, metadata);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Primitive_option.some(error._0);
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateMinPriceToggleField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, state.fieldsStatuses.minPriceToggle, state.submissionStatus, validators_minPriceToggle, status => {
                let init = state.fieldsStatuses;
                return {
                  minPriceToggle: status,
                  minPrice: init.minPrice,
                  maxPriceToggle: init.maxPriceToggle,
                  maxPrice: init.maxPrice,
                  propertyTypesToggle: init.propertyTypesToggle,
                  propertyTypes: init.propertyTypes,
                  mlsStatus: init.mlsStatus,
                  areaGroup: init.areaGroup
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateMinPriceField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, state.fieldsStatuses.minPrice, state.submissionStatus, validators_minPrice, status => {
                let init = state.fieldsStatuses;
                return {
                  minPriceToggle: init.minPriceToggle,
                  minPrice: status,
                  maxPriceToggle: init.maxPriceToggle,
                  maxPrice: init.maxPrice,
                  propertyTypesToggle: init.propertyTypesToggle,
                  propertyTypes: init.propertyTypes,
                  mlsStatus: init.mlsStatus,
                  areaGroup: init.areaGroup
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateMaxPriceToggleField" :
          let nextInput$2 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$2,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$2, metadata, state.fieldsStatuses.maxPriceToggle, state.submissionStatus, validators_maxPriceToggle, status => {
                let init = state.fieldsStatuses;
                return {
                  minPriceToggle: init.minPriceToggle,
                  minPrice: init.minPrice,
                  maxPriceToggle: status,
                  maxPrice: init.maxPrice,
                  propertyTypesToggle: init.propertyTypesToggle,
                  propertyTypes: init.propertyTypes,
                  mlsStatus: init.mlsStatus,
                  areaGroup: init.areaGroup
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateMaxPriceField" :
          let nextInput$3 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$3,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$3, metadata, state.fieldsStatuses.maxPrice, state.submissionStatus, validators_maxPrice, status => {
                let init = state.fieldsStatuses;
                return {
                  minPriceToggle: init.minPriceToggle,
                  minPrice: init.minPrice,
                  maxPriceToggle: init.maxPriceToggle,
                  maxPrice: status,
                  propertyTypesToggle: init.propertyTypesToggle,
                  propertyTypes: init.propertyTypes,
                  mlsStatus: init.mlsStatus,
                  areaGroup: init.areaGroup
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdatePropertyTypesToggleField" :
          let nextInput$4 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$4,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$4, metadata, state.fieldsStatuses.propertyTypesToggle, state.submissionStatus, validators_propertyTypesToggle, status => {
                let init = state.fieldsStatuses;
                return {
                  minPriceToggle: init.minPriceToggle,
                  minPrice: init.minPrice,
                  maxPriceToggle: init.maxPriceToggle,
                  maxPrice: init.maxPrice,
                  propertyTypesToggle: status,
                  propertyTypes: init.propertyTypes,
                  mlsStatus: init.mlsStatus,
                  areaGroup: init.areaGroup
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdatePropertyTypesField" :
          let nextInput$5 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$5,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$5, metadata, state.fieldsStatuses.propertyTypes, state.submissionStatus, validators_propertyTypes, status => {
                let init = state.fieldsStatuses;
                return {
                  minPriceToggle: init.minPriceToggle,
                  minPrice: init.minPrice,
                  maxPriceToggle: init.maxPriceToggle,
                  maxPrice: init.maxPrice,
                  propertyTypesToggle: init.propertyTypesToggle,
                  propertyTypes: status,
                  mlsStatus: init.mlsStatus,
                  areaGroup: init.areaGroup
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateMlsStatusField" :
          let nextInput$6 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$6,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$6, metadata, state.fieldsStatuses.mlsStatus, state.submissionStatus, validators_mlsStatus, status => {
                let init = state.fieldsStatuses;
                return {
                  minPriceToggle: init.minPriceToggle,
                  minPrice: init.minPrice,
                  maxPriceToggle: init.maxPriceToggle,
                  maxPrice: init.maxPrice,
                  propertyTypesToggle: init.propertyTypesToggle,
                  propertyTypes: init.propertyTypes,
                  mlsStatus: status,
                  areaGroup: init.areaGroup
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateAreaGroupField" :
          let nextInput$7 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$7,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$7, metadata, state.fieldsStatuses.areaGroup, state.submissionStatus, validators_areaGroup, status => {
                let init = state.fieldsStatuses;
                return {
                  minPriceToggle: init.minPriceToggle,
                  minPrice: init.minPrice,
                  maxPriceToggle: init.maxPriceToggle,
                  maxPrice: init.maxPrice,
                  propertyTypesToggle: init.propertyTypesToggle,
                  propertyTypes: init.propertyTypes,
                  mlsStatus: init.mlsStatus,
                  areaGroup: status
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: initialFieldsStatuses(input),
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: initialFieldsStatuses(state.input),
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: Primitive_option.some(map(Primitive_option.valFromOption(error$2)))
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateMinPriceToggle: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateMinPriceToggleField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateMinPrice: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateMinPriceField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateMaxPriceToggle: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateMaxPriceToggleField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateMaxPrice: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateMaxPriceField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updatePropertyTypesToggle: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdatePropertyTypesToggleField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updatePropertyTypes: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdatePropertyTypesField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateMlsStatus: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateMlsStatusField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateAreaGroup: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateAreaGroupField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurMinPriceToggle: () => dispatch("BlurMinPriceToggleField"),
    blurMinPrice: () => dispatch("BlurMinPriceField"),
    blurMaxPriceToggle: () => dispatch("BlurMaxPriceToggleField"),
    blurMaxPrice: () => dispatch("BlurMaxPriceField"),
    blurPropertyTypesToggle: () => dispatch("BlurPropertyTypesToggleField"),
    blurPropertyTypes: () => dispatch("BlurPropertyTypesField"),
    blurMlsStatus: () => dispatch("BlurMlsStatusField"),
    blurAreaGroup: () => dispatch("BlurAreaGroupField"),
    minPriceToggleResult: Formality.exposeFieldResult(state.fieldsStatuses.minPriceToggle),
    minPriceResult: Formality.exposeFieldResult(state.fieldsStatuses.minPrice),
    maxPriceToggleResult: Formality.exposeFieldResult(state.fieldsStatuses.maxPriceToggle),
    maxPriceResult: Formality.exposeFieldResult(state.fieldsStatuses.maxPrice),
    propertyTypesToggleResult: Formality.exposeFieldResult(state.fieldsStatuses.propertyTypesToggle),
    propertyTypesResult: Formality.exposeFieldResult(state.fieldsStatuses.propertyTypes),
    mlsStatusResult: Formality.exposeFieldResult(state.fieldsStatuses.mlsStatus),
    areaGroupResult: Formality.exposeFieldResult(state.fieldsStatuses.areaGroup),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.minPriceToggle;
      if (typeof tmp === "object") {
        return true;
      }
      let tmp$1 = match.minPrice;
      if (typeof tmp$1 === "object") {
        return true;
      }
      let tmp$2 = match.maxPriceToggle;
      if (typeof tmp$2 === "object") {
        return true;
      }
      let tmp$3 = match.maxPrice;
      if (typeof tmp$3 === "object") {
        return true;
      }
      let tmp$4 = match.propertyTypesToggle;
      if (typeof tmp$4 === "object") {
        return true;
      }
      let tmp$5 = match.propertyTypes;
      if (typeof tmp$5 === "object") {
        return true;
      }
      let tmp$6 = match.mlsStatus;
      if (typeof tmp$6 === "object") {
        return true;
      }
      let tmp$7 = match.areaGroup;
      return typeof tmp$7 === "object";
    },
    valid: () => {
      let apply_validate = validateForm;
      let match = apply_validate(state.input, validators, state.fieldsStatuses, metadata);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let FormConfig = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

let convertVariables = NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql.Internal.convertVariables;

let convertResponse = NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let UpdateUserNotificationPreferenceV5Mutation_forSalePropertyTypeEnumV5_decode = NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let UpdateUserNotificationPreferenceV5Mutation_forSalePropertyTypeEnumV5_fromString = NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let UpdateUserNotificationPreferenceV5Mutation_propertyNotificationPreferenceMLSStatus_decode = NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql.Utils.propertyNotificationPreferenceMLSStatus_decode;

let UpdateUserNotificationPreferenceV5Mutation_propertyNotificationPreferenceMLSStatus_fromString = NotificationSettingsPreferenceEditDialog_UpdateUserNotificationPreferenceV5Mutation_graphql.Utils.propertyNotificationPreferenceMLSStatus_fromString;

let UpdateUserNotificationPreferenceV5Mutation = {
  forSalePropertyTypeEnumV5_decode: UpdateUserNotificationPreferenceV5Mutation_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: UpdateUserNotificationPreferenceV5Mutation_forSalePropertyTypeEnumV5_fromString,
  propertyNotificationPreferenceMLSStatus_decode: UpdateUserNotificationPreferenceV5Mutation_propertyNotificationPreferenceMLSStatus_decode,
  propertyNotificationPreferenceMLSStatus_fromString: UpdateUserNotificationPreferenceV5Mutation_propertyNotificationPreferenceMLSStatus_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

let forSalePropertyTypeEnumV5_decode = NotificationSettingsPreferenceEditDialog_preference_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let propertyNotificationPreferenceMLSStatus_decode = NotificationSettingsPreferenceEditDialog_preference_graphql.Utils.propertyNotificationPreferenceMLSStatus_decode;

let convertFragment = NotificationSettingsPreferenceEditDialog_preference_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsPreferenceEditDialog_preference_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialog_preference_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettingsPreferenceEditDialog_preference_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsPreferenceEditDialog_preference_graphql.node, convertFragment, fRef);
}

let PreferenceFragment_forSalePropertyTypeEnumV5_fromString = NotificationSettingsPreferenceEditDialog_preference_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let PreferenceFragment_propertyNotificationPreferenceMLSStatus_fromString = NotificationSettingsPreferenceEditDialog_preference_graphql.Utils.propertyNotificationPreferenceMLSStatus_fromString;

let PreferenceFragment = {
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: PreferenceFragment_forSalePropertyTypeEnumV5_fromString,
  propertyNotificationPreferenceMLSStatus_decode: propertyNotificationPreferenceMLSStatus_decode,
  propertyNotificationPreferenceMLSStatus_fromString: PreferenceFragment_propertyNotificationPreferenceMLSStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = NotificationSettingsPreferenceEditDialog_clientNeed_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsPreferenceEditDialog_clientNeed_graphql.node, convertFragment$1, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialog_clientNeed_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettingsPreferenceEditDialog_clientNeed_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsPreferenceEditDialog_clientNeed_graphql.node, convertFragment$1, fRef);
}

let ClientNeedFragment_forSalePropertyTypeEnumV5_decode = NotificationSettingsPreferenceEditDialog_clientNeed_graphql.Utils.forSalePropertyTypeEnumV5_decode;

let ClientNeedFragment_forSalePropertyTypeEnumV5_fromString = NotificationSettingsPreferenceEditDialog_clientNeed_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

let ClientNeedFragment = {
  forSalePropertyTypeEnumV5_decode: ClientNeedFragment_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: ClientNeedFragment_forSalePropertyTypeEnumV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$2,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let areaTypeV5_decode = NotificationSettingsPreferenceEditDialog_areaGroup_graphql.Utils.areaTypeV5_decode;

let matchableEntityType_decode = NotificationSettingsPreferenceEditDialog_areaGroup_graphql.Utils.matchableEntityType_decode;

let convertFragment$2 = NotificationSettingsPreferenceEditDialog_areaGroup_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsPreferenceEditDialog_areaGroup_graphql.node, convertFragment$2, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialog_areaGroup_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettingsPreferenceEditDialog_areaGroup_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsPreferenceEditDialog_areaGroup_graphql.node, convertFragment$2, fRef);
}

let AreaGroupFragment_areaTypeV5_fromString = NotificationSettingsPreferenceEditDialog_areaGroup_graphql.Utils.areaTypeV5_fromString;

let AreaGroupFragment_matchableEntityType_fromString = NotificationSettingsPreferenceEditDialog_areaGroup_graphql.Utils.matchableEntityType_fromString;

let AreaGroupFragment = {
  areaTypeV5_decode: areaTypeV5_decode,
  areaTypeV5_fromString: AreaGroupFragment_areaTypeV5_fromString,
  matchableEntityType_decode: matchableEntityType_decode,
  matchableEntityType_fromString: AreaGroupFragment_matchableEntityType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$3,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

let convertFragment$3 = NotificationSettingsPreferenceEditDialog_chapter_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsPreferenceEditDialog_chapter_graphql.node, convertFragment$3, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialog_chapter_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettingsPreferenceEditDialog_chapter_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsPreferenceEditDialog_chapter_graphql.node, convertFragment$3, fRef);
}

let ChapterFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$4,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

let convertFragment$4 = NotificationSettingsPreferenceEditDialog_settings_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettingsPreferenceEditDialog_settings_graphql.node, convertFragment$4, fRef);
}

function use$5(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialog_settings_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationSettingsPreferenceEditDialog_settings_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettingsPreferenceEditDialog_settings_graphql.node, convertFragment$4, fRef);
}

let SettingsFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$5,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

function NotificationSettingsPreferenceEditDialog(props) {
  let onClose = props.onClose;
  let entityType = props.entityType;
  let settings = RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialog_settings_graphql.node, convertFragment$4, props.settings);
  let match = use();
  let updatePreference = match[0];
  let chapter = RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialog_chapter_graphql.node, convertFragment$3, props.chapter);
  let match$1 = SystemMessages.useSystemMessages();
  let addMessage = match$1.addMessage;
  let handleFailure = () => addMessage(SystemMessages.Message.make(V4(), "error", "There was an error updating your preferences", 5000, undefined, undefined));
  let handleSuccess = () => addMessage(SystemMessages.Message.make(V4(), "info", "Updated notification settings", 5000, undefined, undefined));
  let tmp;
  if (typeof entityType === "object") {
    let variant = entityType.NAME;
    if (variant === "RENTAL_PROPERTY" || variant === "FOR_SALE_PROPERTY") {
      let fragmentRefs = entityType.VAL;
      tmp = fragmentRefs !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fragmentRefs)) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  let propertyPreference = useOpt(tmp);
  let tmp$1;
  if (typeof entityType === "object") {
    let variant$1 = entityType.NAME;
    if (variant$1 === "RENTAL_NEED" || variant$1 === "BUYER_NEED") {
      let fragmentRefs$1 = entityType.VAL;
      tmp$1 = fragmentRefs$1 !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fragmentRefs$1)) : undefined;
    } else {
      tmp$1 = undefined;
    }
  } else {
    tmp$1 = undefined;
  }
  let clientNeedPreference = useOpt$1(tmp$1);
  let preference;
  if (typeof entityType === "object") {
    let variant$2 = entityType.NAME;
    preference = variant$2 === "BUYER_NEED" ? ({
        NAME: "BUYER_NEED",
        VAL: clientNeedPreference
      }) : (
        variant$2 === "FOR_SALE_PROPERTY" ? ({
            NAME: "FOR_SALE_PROPERTY",
            VAL: propertyPreference
          }) : (
            variant$2 === "RENTAL_NEED" ? ({
                NAME: "RENTAL_NEED",
                VAL: clientNeedPreference
              }) : (
                variant$2 === "RENTAL_PROPERTY" ? ({
                    NAME: "RENTAL_PROPERTY",
                    VAL: propertyPreference
                  }) : Stdlib.panic("Entity type did not match. This should not happen.")
              )
          )
      );
  } else {
    preference = Stdlib.panic("Entity type did not match. This should not happen.");
  }
  let variant$3 = preference.NAME;
  let preferenceType = variant$3 === "FOR_SALE_PROPERTY" ? "FOR_SALE_PROPERTY" : (
      variant$3 === "RENTAL_NEED" ? "RENTAL_NEED" : (
          variant$3 === "RENTAL_PROPERTY" ? "RENTAL_PROPERTY" : "BUYER_NEED"
        )
    );
  let match$2 = chapter.notificationPreferences;
  let fRef;
  switch (preferenceType) {
    case "BUYER_NEED" :
      fRef = match$2 !== undefined ? match$2.buyerNeeds.areaGroup.fragmentRefs : Stdlib.panic("Did not find expected chapter area group.");
      break;
    case "FOR_SALE_PROPERTY" :
      fRef = match$2 !== undefined ? match$2.forSaleProperties.areaGroup.fragmentRefs : Stdlib.panic("Did not find expected chapter area group.");
      break;
    case "NEW_DEVELOPMENT" :
      fRef = Stdlib.panic("Did not find expected chapter area group.");
      break;
    case "RENTAL_NEED" :
      fRef = match$2 !== undefined ? match$2.rentalNeeds.areaGroup.fragmentRefs : Stdlib.panic("Did not find expected chapter area group.");
      break;
    case "RENTAL_PROPERTY" :
      fRef = match$2 !== undefined ? match$2.rentalProperties.areaGroup.fragmentRefs : Stdlib.panic("Did not find expected chapter area group.");
      break;
  }
  let chapterDefaultAreaGroup = RescriptRelay_Fragment.useFragment(NotificationSettingsPreferenceEditDialog_areaGroup_graphql.node, convertFragment$2, fRef);
  let tmp$2;
  if (typeof preference === "object") {
    let variant$4 = preference.NAME;
    if (variant$4 === "BUYER_NEED") {
      let match$3 = preference.VAL;
      if (match$3 !== undefined) {
        let match$4 = match$3.areaGroup;
        tmp$2 = match$4 !== undefined ? Primitive_option.some(match$4.fragmentRefs) : undefined;
      } else {
        tmp$2 = undefined;
      }
    } else if (variant$4 === "FOR_SALE_PROPERTY") {
      let match$5 = preference.VAL;
      if (match$5 !== undefined) {
        let match$6 = match$5.areaGroup;
        tmp$2 = match$6 !== undefined ? Primitive_option.some(match$6.fragmentRefs) : undefined;
      } else {
        tmp$2 = undefined;
      }
    } else if (variant$4 === "RENTAL_NEED") {
      let match$7 = preference.VAL;
      if (match$7 !== undefined) {
        let match$8 = match$7.areaGroup;
        tmp$2 = match$8 !== undefined ? Primitive_option.some(match$8.fragmentRefs) : undefined;
      } else {
        tmp$2 = undefined;
      }
    } else if (variant$4 === "RENTAL_PROPERTY") {
      let match$9 = preference.VAL;
      if (match$9 !== undefined) {
        let match$10 = match$9.areaGroup;
        tmp$2 = match$10 !== undefined ? Primitive_option.some(match$10.fragmentRefs) : undefined;
      } else {
        tmp$2 = undefined;
      }
    } else {
      tmp$2 = undefined;
    }
  } else {
    tmp$2 = undefined;
  }
  let currentAreaGroup = useOpt$2(tmp$2);
  let variant$5 = preference.NAME;
  let tanType = variant$5 === "RENTAL_PROPERTY" || variant$5 === "RENTAL_NEED" ? "RENTAL" : "FOR_SALE";
  let match$11 = preference.VAL;
  let variant$6 = preference.NAME;
  let match$12 = preference.VAL;
  let variant$7 = preference.NAME;
  let variant$8 = preference.NAME;
  let tmp$3;
  if (variant$8 === "RENTAL_PROPERTY" || variant$8 === "FOR_SALE_PROPERTY") {
    let match$13 = preference.VAL;
    tmp$3 = match$13 !== undefined ? Stdlib_Option.isSome(match$13.propertyTypes) : false;
  } else {
    let match$14 = preference.VAL;
    tmp$3 = match$14 !== undefined ? Stdlib_Option.isSome(match$14.propertyTypes) : false;
  }
  let tmp$4;
  let exit = 0;
  let propertyTypes;
  let variant$9 = preference.NAME;
  if (variant$9 === "RENTAL_PROPERTY" || variant$9 === "FOR_SALE_PROPERTY") {
    let match$15 = preference.VAL;
    if (match$15 !== undefined) {
      propertyTypes = match$15.propertyTypes;
      exit = 1;
    } else {
      tmp$4 = [];
    }
  } else {
    let match$16 = preference.VAL;
    if (match$16 !== undefined) {
      propertyTypes = match$16.propertyTypes;
      exit = 1;
    } else {
      tmp$4 = [];
    }
  }
  if (exit === 1) {
    tmp$4 = Stdlib_Array.filterMap(Stdlib_Option.getOr(propertyTypes, []), v => forSalePropertyTypeEnumV5_decode(v));
  }
  let variant$10 = preference.NAME;
  let tmp$5;
  if (variant$10 === "RENTAL_PROPERTY" || variant$10 === "FOR_SALE_PROPERTY") {
    let match$17 = preference.VAL;
    tmp$5 = match$17 !== undefined ? Stdlib_Option.getOr(Stdlib_Option.flatMap(match$17.mlsStatus, propertyNotificationPreferenceMLSStatus_decode), "ANY") : "ANY";
  } else {
    tmp$5 = "ANY";
  }
  let tmp$6;
  if (currentAreaGroup !== undefined) {
    switch (currentAreaGroup.__typename) {
      case "ChapterAreaGroup" :
        tmp$6 = {
          TAG: "ChapterAreaGroup",
          id: currentAreaGroup.id,
          areas: Stdlib_Array.filterMap(Stdlib_Array.keepSome(Stdlib_Option.getOr(currentAreaGroup.areas, [])), a => Stdlib_Option.map(areaTypeV5_decode(a.type_), t => ({
            id: a.id,
            label: a.label,
            type_: t
          })))
        };
        break;
      case "UserAreaGroup" :
        tmp$6 = {
          TAG: "UserAreaGroup",
          id: currentAreaGroup.id,
          areas: Stdlib_Array.filterMap(Stdlib_Array.keepSome(Stdlib_Option.getOr(currentAreaGroup.areas, [])), a => Stdlib_Option.map(areaTypeV5_decode(a.type_), t => ({
            id: a.id,
            label: a.label,
            type_: t
          }))),
          usedFor: Stdlib_Array.filterMap(Stdlib_Option.getOr(currentAreaGroup.usedFor, []), v => matchableEntityType_decode(v))
        };
        break;
      case "__unselected" :
        tmp$6 = Stdlib.panic("Did not expect there to be no existing area group.");
        break;
    }
  } else {
    switch (chapterDefaultAreaGroup.__typename) {
      case "ChapterAreaGroup" :
        tmp$6 = {
          TAG: "ChapterAreaGroup",
          id: chapterDefaultAreaGroup.id,
          areas: Stdlib_Array.filterMap(Stdlib_Array.keepSome(Stdlib_Option.getOr(chapterDefaultAreaGroup.areas, [])), a => Stdlib_Option.map(areaTypeV5_decode(a.type_), t => ({
            id: a.id,
            label: a.label,
            type_: t
          })))
        };
        break;
      case "UserAreaGroup" :
        tmp$6 = {
          TAG: "UserAreaGroup",
          id: chapterDefaultAreaGroup.id,
          areas: Stdlib_Array.filterMap(Stdlib_Array.keepSome(Stdlib_Option.getOr(chapterDefaultAreaGroup.areas, [])), a => Stdlib_Option.map(areaTypeV5_decode(a.type_), t => ({
            id: a.id,
            label: a.label,
            type_: t
          }))),
          usedFor: Stdlib_Array.filterMap(Stdlib_Option.getOr(chapterDefaultAreaGroup.usedFor, []), v => matchableEntityType_decode(v))
        };
        break;
      case "__unselected" :
        tmp$6 = Stdlib.panic("Did not expect there to be no existing area group.");
        break;
    }
  }
  let form = useForm({
    minPriceToggle: match$11 !== undefined ? Stdlib_Option.isSome(match$11.minPrice) : false,
    minPrice: variant$6 === "RENTAL_PROPERTY" || variant$6 === "FOR_SALE_PROPERTY" ? Stdlib_Option.flatMap(preference.VAL, x => x.minPrice) : Stdlib_Option.flatMap(preference.VAL, x => x.minPrice),
    maxPriceToggle: match$12 !== undefined ? Stdlib_Option.isSome(match$12.maxPrice) : false,
    maxPrice: variant$7 === "RENTAL_PROPERTY" || variant$7 === "FOR_SALE_PROPERTY" ? Stdlib_Option.flatMap(preference.VAL, x => x.maxPrice) : Stdlib_Option.flatMap(preference.VAL, x => x.maxPrice),
    propertyTypesToggle: tmp$3,
    propertyTypes: tmp$4,
    mlsStatus: tmp$5,
    areaGroup: tmp$6
  }, {
    tanType: tanType
  }, (output, param) => {
    let notifyOnFailure = param.notifyOnFailure;
    let notifyOnSuccess = param.notifyOnSuccess;
    let minPrice = output.minPriceToggle ? output.minPrice : undefined;
    let maxPrice = output.maxPriceToggle ? output.maxPrice : undefined;
    let propertyTypes = output.propertyTypesToggle ? output.propertyTypes : undefined;
    let mlsStatus = output.mlsStatus;
    let match = output.areaGroup;
    let areas;
    let exit = 0;
    let areas$1;
    switch (match.TAG) {
      case "UserAreaGroup" :
      case "ChapterAreaGroup" :
        areas$1 = match.areas;
        exit = 1;
        break;
      case "NewAreaGroup" :
        areas$1 = match.areas;
        exit = 1;
        break;
    }
    if (exit === 1) {
      areas = areas$1.map(a => ({
        areaId: a.id
      }));
    }
    let match$1 = output.areaGroup;
    let areaGroup;
    switch (match$1.TAG) {
      case "UserAreaGroup" :
        areaGroup = {
          __$inputUnion: "userAreaGroup",
          _0: {
            areas: areas,
            id: match$1.id
          }
        };
        break;
      case "ChapterAreaGroup" :
        areaGroup = {
          __$inputUnion: "chapterDefault",
          _0: true
        };
        break;
      case "NewAreaGroup" :
        areaGroup = {
          __$inputUnion: "newUserAreaGroup",
          _0: {
            areas: areas
          }
        };
        break;
    }
    let tmp;
    switch (preferenceType) {
      case "BUYER_NEED" :
        tmp = {
          __$inputUnion: "buyerNeeds",
          _0: {
            areaGroup: areaGroup,
            maxPrice: maxPrice,
            minPrice: minPrice,
            propertyTypes: propertyTypes
          }
        };
        break;
      case "FOR_SALE_PROPERTY" :
        tmp = {
          __$inputUnion: "property",
          _0: {
            areaGroup: areaGroup,
            maxPrice: maxPrice,
            minPrice: minPrice,
            mlsStatus: mlsStatus,
            propertyTypes: propertyTypes
          }
        };
        break;
      case "NEW_DEVELOPMENT" :
        tmp = UnselectedUnionMemberError.raise("New developments use the area-only settings dialog");
        break;
      case "RENTAL_NEED" :
        tmp = {
          __$inputUnion: "rentalNeeds",
          _0: {
            areaGroup: areaGroup,
            maxPrice: maxPrice,
            minPrice: minPrice,
            propertyTypes: propertyTypes
          }
        };
        break;
      case "RENTAL_PROPERTY" :
        tmp = {
          __$inputUnion: "rentalProperty",
          _0: {
            areaGroup: areaGroup,
            maxPrice: maxPrice,
            minPrice: minPrice,
            mlsStatus: mlsStatus,
            propertyTypes: propertyTypes
          }
        };
        break;
    }
    updatePreference({
      input: tmp
    }, undefined, undefined, undefined, (param, param$1) => {
      let updateUserNotificationPreferenceV5 = param.updateUserNotificationPreferenceV5;
      if (updateUserNotificationPreferenceV5 !== undefined) {
        if (updateUserNotificationPreferenceV5.__typename === "UserNotificationPreferenceWasUpdated") {
          notifyOnSuccess(undefined);
          handleSuccess();
          return onClose();
        }
        notifyOnFailure();
        handleFailure();
        return onClose();
      }
      notifyOnFailure();
      handleFailure();
      onClose();
    }, undefined, undefined);
  });
  let match$18 = React.useState(() => form.input);
  let initialFormState = match$18[0];
  let title = "Edit " + NotificationSettingsUtils.toDisplayStringSingular(preferenceType) + " filters";
  let match$19 = React.useState(() => false);
  let setConfirmDiscardDialogIsOpen = match$19[1];
  let match$20 = React.useState(() => false);
  let setUserHasMadeChanges = match$20[1];
  let userHasMadeChanges = match$20[0];
  let onCloseEditingDialog = () => {
    if (userHasMadeChanges) {
      return setConfirmDiscardDialogIsOpen(param => true);
    } else {
      return onClose();
    }
  };
  React.useEffect(() => {
    setUserHasMadeChanges(param => Primitive_object.notequal(initialFormState, form.input));
  }, [form.input]);
  let selectablePropertyTypes = tanType === "RENTAL" ? [
      "SINGLE_FAMILY",
      "CONDO"
    ] : [
      "SINGLE_FAMILY",
      "MULTI_UNIT",
      "CONDO",
      "LOT"
    ];
  let isMobile = MediaQuery.isMobile();
  let match$21 = form.input;
  let hasAtLeastOneCustomFilter;
  if (match$21.maxPriceToggle || match$21.propertyTypesToggle) {
    hasAtLeastOneCustomFilter = true;
  } else {
    switch (match$21.areaGroup.TAG) {
      case "ChapterAreaGroup" :
        hasAtLeastOneCustomFilter = match$21.mlsStatus === "ANY" ? match$21.minPriceToggle : true;
        break;
      case "UserAreaGroup" :
      case "NewAreaGroup" :
        hasAtLeastOneCustomFilter = true;
        break;
    }
  }
  let variant$11 = preference.NAME;
  let minPrice = form.input.minPrice;
  let match$22 = form.minPriceResult;
  let tmp$7;
  tmp$7 = match$22 !== undefined ? (
      match$22.TAG === "Ok" ? (
          match$22._0 !== undefined ? ({
              TAG: "Ok",
              _0: "Valid"
            }) : ({
              TAG: "Ok",
              _0: "NoValue"
            })
        ) : ({
          TAG: "Error",
          _0: match$22._0
        })
    ) : undefined;
  let maxPrice = form.input.maxPrice;
  let match$23 = form.maxPriceResult;
  let tmp$8;
  tmp$8 = match$23 !== undefined ? (
      match$23.TAG === "Ok" ? (
          match$23._0 !== undefined ? ({
              TAG: "Ok",
              _0: "Valid"
            }) : ({
              TAG: "Ok",
              _0: "NoValue"
            })
        ) : ({
          TAG: "Error",
          _0: match$23._0
        })
    ) : undefined;
  let variant$12 = preference.NAME;
  return JsxRuntime.jsx(DialogV5.make, {
    title: title,
    isOpen: props.isOpen,
    ariaLabel: title,
    onDismiss: onCloseEditingDialog,
    size: "XXLarge",
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(NotificationSettingsPreferenceEditDialog$ConfirmDiscardChangesDialog, {
          isOpen: match$19[0],
          onKeepChanges: () => setConfirmDiscardDialogIsOpen(param => false),
          onDiscardChanges: () => {
            setConfirmDiscardDialogIsOpen(param => false);
            onClose();
          }
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: "Turn filters on to customize which " + (
                variant$11 === "FOR_SALE_PROPERTY" ? "property" : (
                    variant$11 === "RENTAL_NEED" ? "rental need" : (
                        variant$11 === "RENTAL_PROPERTY" ? "rental property" : "buyer need"
                      )
                  )
              ) + " emails you receive",
              className: "mb-4"
            }),
            JsxRuntime.jsx(NotificationSettingsPreferenceEditDialog$CheckSection, {
              isOpen: form.input.minPriceToggle,
              title: "Minimum Price",
              children: JsxRuntime.jsx(Form__Components.TextInputField.make, {
                value: minPrice !== undefined ? Numeral.formatNumber(minPrice) : "",
                onBlur: param => form.blurMinPrice(),
                onChange: e => {
                  e.preventDefault();
                  let value = Stdlib_Int.fromString(Form__Helpers.stripNonDigits(e.target.value), undefined);
                  form.updateMinPrice((v, value) => ({
                    minPriceToggle: v.minPriceToggle,
                    minPrice: value,
                    maxPriceToggle: v.maxPriceToggle,
                    maxPrice: v.maxPrice,
                    propertyTypesToggle: v.propertyTypesToggle,
                    propertyTypes: v.propertyTypes,
                    mlsStatus: v.mlsStatus,
                    areaGroup: v.areaGroup
                  }), value);
                },
                validationResult: tmp$7,
                prepend: "$"
              }),
              onUpdate: f => form.updateMinPriceToggle((input, v) => ({
                minPriceToggle: v,
                minPrice: input.minPrice,
                maxPriceToggle: input.maxPriceToggle,
                maxPrice: input.maxPrice,
                propertyTypesToggle: input.propertyTypesToggle,
                propertyTypes: input.propertyTypes,
                mlsStatus: input.mlsStatus,
                areaGroup: input.areaGroup
              }), f)
            }),
            JsxRuntime.jsx(NotificationSettingsPreferenceEditDialog$CheckSection, {
              isOpen: form.input.maxPriceToggle,
              title: "Maximum Price",
              children: JsxRuntime.jsx(Form__Components.TextInputField.make, {
                value: maxPrice !== undefined ? Numeral.formatNumber(maxPrice) : "",
                onBlur: param => form.blurMaxPrice(),
                onChange: e => {
                  e.preventDefault();
                  let value = Stdlib_Int.fromString(Form__Helpers.stripNonDigits(e.target.value), undefined);
                  form.updateMaxPrice((v, value) => ({
                    minPriceToggle: v.minPriceToggle,
                    minPrice: v.minPrice,
                    maxPriceToggle: v.maxPriceToggle,
                    maxPrice: value,
                    propertyTypesToggle: v.propertyTypesToggle,
                    propertyTypes: v.propertyTypes,
                    mlsStatus: v.mlsStatus,
                    areaGroup: v.areaGroup
                  }), value);
                },
                validationResult: tmp$8,
                prepend: "$"
              }),
              onUpdate: f => form.updateMinPriceToggle((input, v) => ({
                minPriceToggle: input.minPriceToggle,
                minPrice: input.minPrice,
                maxPriceToggle: v,
                maxPrice: input.maxPrice,
                propertyTypesToggle: input.propertyTypesToggle,
                propertyTypes: input.propertyTypes,
                mlsStatus: input.mlsStatus,
                areaGroup: input.areaGroup
              }), f)
            }),
            JsxRuntime.jsxs(NotificationSettingsPreferenceEditDialog$CheckSection, {
              isOpen: form.input.propertyTypesToggle,
              title: "Property Types",
              children: [
                JsxRuntime.jsx(TogglesGroup.make, {
                  children: selectablePropertyTypes.map(ptype => {
                    let checked = form.input.propertyTypes.includes(ptype);
                    let label;
                    switch (ptype) {
                      case "CONDO" :
                        label = "Condo/Townhouse";
                        break;
                      case "LOT" :
                        label = "Lot";
                        break;
                      case "MULTI_UNIT" :
                        label = "Multi unit";
                        break;
                      case "SINGLE_FAMILY" :
                        label = "Single family";
                        break;
                    }
                    return JsxRuntime.jsx(Form__Checkbox.make, {
                      onChange: param => form.updatePropertyTypes((input, propertyTypes) => ({
                        minPriceToggle: input.minPriceToggle,
                        minPrice: input.minPrice,
                        maxPriceToggle: input.maxPriceToggle,
                        maxPrice: input.maxPrice,
                        propertyTypesToggle: input.propertyTypesToggle,
                        propertyTypes: propertyTypes,
                        mlsStatus: input.mlsStatus,
                        areaGroup: input.areaGroup
                      }), checked ? form.input.propertyTypes.filter(v => v !== ptype) : Belt_Array.concatMany([
                          form.input.propertyTypes,
                          [ptype]
                        ])),
                      checked: checked,
                      label: label,
                      mobileStyles: true
                    }, label);
                  })
                }),
                JsxRuntime.jsx(Form__Components.FieldErrorV2.make, {
                  valid: form.propertyTypesResult
                })
              ],
              onUpdate: f => form.updatePropertyTypesToggle((input, v) => ({
                minPriceToggle: input.minPriceToggle,
                minPrice: input.minPrice,
                maxPriceToggle: input.maxPriceToggle,
                maxPrice: input.maxPrice,
                propertyTypesToggle: v,
                propertyTypes: input.propertyTypes,
                mlsStatus: input.mlsStatus,
                areaGroup: input.areaGroup
              }), f)
            }),
            variant$12 === "RENTAL_PROPERTY" || variant$12 === "FOR_SALE_PROPERTY" ? JsxRuntime.jsx(NotificationSettingsPreferenceEditDialog$CheckSection, {
                isOpen: form.input.mlsStatus === "NOT_ACTIVE_ON_MLS",
                title: isMobile ? "Not active on the MLS" : "Only " + (NotificationSettingsUtils.toDisplayStringPlural(preferenceType) + " not currently active on the MLS"),
                children: null,
                onUpdate: value => form.updateMlsStatus((input, v) => ({
                  minPriceToggle: input.minPriceToggle,
                  minPrice: input.minPrice,
                  maxPriceToggle: input.maxPriceToggle,
                  maxPrice: input.maxPrice,
                  propertyTypesToggle: input.propertyTypesToggle,
                  propertyTypes: input.propertyTypes,
                  mlsStatus: v,
                  areaGroup: input.areaGroup
                }), value ? "NOT_ACTIVE_ON_MLS" : "ANY"),
                helpText: "You will not receive broadcasts about " + (NotificationSettingsUtils.toDisplayStringPlural(preferenceType) + " that are currently active on the MLS")
              }) : null
          ],
          className: ""
        }),
        JsxRuntime.jsx(NotificationSettingsPreferenceEditDialogAreaGroups.make, {
          chapter: chapter.fragmentRefs,
          settings: settings.fragmentRefs,
          currentAreaGroup: form.input.areaGroup,
          setAreaGroup: areaGroup => form.updateAreaGroup((input, areaGroup) => ({
            minPriceToggle: input.minPriceToggle,
            minPrice: input.minPrice,
            maxPriceToggle: input.maxPriceToggle,
            maxPrice: input.maxPrice,
            propertyTypesToggle: input.propertyTypesToggle,
            propertyTypes: input.propertyTypes,
            mlsStatus: input.mlsStatus,
            areaGroup: areaGroup
          }), areaGroup),
          preferenceType: preferenceType,
          fieldResult: form.areaGroupResult
        }),
        !hasAtLeastOneCustomFilter && userHasMadeChanges ? JsxRuntime.jsx(Alert.$$Error.make, {
            title: "You must select at least one custom filter",
            className: "shadow-sm"
          }) : null,
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
                onClick: param => onCloseEditingDialog(),
                size: "huge",
                children: userHasMadeChanges ? "Discard Changes" : "Cancel"
              }),
              className: "mr-16"
            }),
            JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
              onClick: e => {
                e.preventDefault();
                form.submit();
              },
              disabled: !userHasMadeChanges || match[1] || form.submitting || !hasAtLeastOneCustomFilter,
              size: "large",
              children: "Save Changes"
            })
          ],
          className: "flex flex-row items-baseline justify-end mt-4 p-4"
        })
      ],
      className: "w-full bg-white"
    })
  });
}

let make = NotificationSettingsPreferenceEditDialog;

exports.CheckSection = CheckSection;
exports.ConfirmDiscardChangesDialog = ConfirmDiscardChangesDialog;
exports.FormConfig = FormConfig;
exports.UpdateUserNotificationPreferenceV5Mutation = UpdateUserNotificationPreferenceV5Mutation;
exports.PreferenceFragment = PreferenceFragment;
exports.ClientNeedFragment = ClientNeedFragment;
exports.AreaGroupFragment = AreaGroupFragment;
exports.ChapterFragment = ChapterFragment;
exports.SettingsFragment = SettingsFragment;
exports.make = make;
/* commitMutation Not a pure module */
